module.exports = __webpack_public_path__ + "img/12.be05cb09.jpg";